import { Component, Input } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { Store } from '@ngrx/store';

import { ProfileIcebreakersEditDialogService } from '@main-client/src/app/profile/profile-icebreakers-edit-dialog/profile-icebreakers-edit-dialog.service';
import { ProfileMessageDialogService } from '@main-client/src/app/profile/profile-message-dialog/profile-message-dialog.service';

import { Account, AccountIcebreaker } from '@libs/src/models/account.model';
import { IAppState } from '@main-client/src/app/app.state';
import { Icebreaker } from '@main-client/src/app/icebreakers/icebreaker.model';

@Component({
  selector: 'app-profile-icebreakers',
  templateUrl: './profile-icebreakers.component.html',
})
export class ProfileIcebreakersComponent {
  @Input() isUser: boolean;
  @Input() profile: Account;
  @Input() tenantIceBreakers: Icebreaker[];
  @Input() user: Account;
  dialogRef: MatDialogRef<any>;
  isLoading = false;
  tenant = this.store.select('tenant');

  constructor(
    public icebreakerDialog: ProfileIcebreakersEditDialogService,
    public messageDialog: ProfileMessageDialogService,
    public store: Store<IAppState>,
  ) {}

  openEditDialog() {
    return this.icebreakerDialog
      .openEditDialog(
        this.isUser,
        this.tenantIceBreakers,
        this.profile,
        this.user,
      )
      .subscribe();
  }

  openMessageDialog(icebreaker: AccountIcebreaker) {
    const message = $localize`:@@profileView.messageDialog.defaultMessage.option1:Hi ${this.profile.first_name} 👋\n\nI'm interested in your icebreaker: "${icebreaker.question} ${icebreaker.answer}"`;
    this.messageDialog
      .openDialog({
        message,
        analyticNameSuffix: 'icebreaker',
        profile: this.profile,
        user: this.user,
      })
      .subscribe();
  }
}
